import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/Icons/White/plane.svg'


const _hoisted_1 = { class: "text-input" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  role: "presentation"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

interface Props {
    modelValue: string
    shouldFocus?: boolean
    borderClass?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReceiveTextField',
  props: {
    modelValue: {},
    shouldFocus: { type: Boolean, default: false },
    borderClass: { default: 'grey' }
  },
  emits: ['submitReplyText', 'update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const submitReplyText = (evt) => {
    evt.preventDefault()
    emit('submitReplyText', evt.target.value)
}

const onKeyPress = (evt) => {
    if (evt.keyCode === 13 && evt.shiftKey) {
        submitReplyText(evt)
    }
}

return (_ctx: any,_cache: any) => {
  const _directive_autoexpand_height = _resolveDirective("autoexpand-height")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("textarea", {
      autofocus: "",
      "aria-label": "Your answer to the question",
      class: _normalizeClass(_ctx.borderClass),
      value: props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event?.target?.value))),
      onKeypress: onKeyPress
    }, null, 42, _hoisted_2), [
      [_directive_autoexpand_height]
    ]),
    _createElementVNode("button", {
      type: "submit",
      "aria-label": "Submit Answer",
      disabled: !_ctx.modelValue,
      onClick: submitReplyText
    }, _hoisted_5, 8, _hoisted_3)
  ]))
}
}

})